module.exports = __webpack_public_path__ + "static/scale-model-of-lichgate-on-high-road-in-tallahassee-florida-f4ef912bd1c4f20eb2fa4acb5fc553b6.png";